import React from 'react';

import {ScrollView, Typography, View, XStack} from '@medad-sep/core';
import {LanguageIcon} from '@medad-sep/shell-default/components/MainHeader/components/Language';
import {PagesItems} from '@medad-sep/shell-default/components/PagesList';
import {PageItem} from '@medad-sep/shell-default/components/PagesList/PageItem';
import {AuthAction} from '@medad-sep/shell-default/screens/Settings/sections/SettingsMain/components/AuthAction';

export const Main = ({pageItems}: {pageItems: PagesItems}) => {
  return (
    <ScrollView>
      <View flex={1} justifyContent="center" flexDirection="row" flexWrap="wrap">
        <XStack width="100%" padding="$1" justifyContent="space-between" alignItems="center">
          <Typography color="$brand-600" fontWeight="700" fontSize={24}>
            Playground
          </Typography>

          <XStack space="$1">
            <LanguageIcon />
            <AuthAction />
          </XStack>
        </XStack>

        {pageItems.map((page, i) => (
          <PageItem key={page.id} id={page.id} icon={page.icon} title={page.title} index={i} />
        ))}
      </View>
    </ScrollView>
  );
};
